import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";

export default function InfoPage({
  eyebrow,
  title,
  intro,
  sections = [],
  testId,
  lastUpdated = "December 2025",
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={testId} className="bg-white text-[#050B14]">
      <Navigation />

      <main>
        <section className="relative bg-[#F4F8FC] pt-40 md:pt-48 pb-14 md:pb-20 border-b border-[#E5EBF2]">
          <div className="max-w-5xl mx-auto px-6 md:px-12">
            <Link
              to="/"
              data-testid="info-back-home"
              className="group inline-flex items-center gap-2 text-sm font-medium text-[#0E2A57] hover:text-[#2BB6E5] transition-colors mb-8"
            >
              <ArrowLeft size={16} className="transition-transform group-hover:-translate-x-1" />
              Back to home
            </Link>

            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-16 bg-[#2BB6E5]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#0E2A57] font-semibold">
                {eyebrow}
              </span>
            </div>
            <h1 className="font-heading font-extrabold text-4xl md:text-6xl leading-[1.0] tracking-[-0.04em] text-[#0E2A57]">
              {title}
            </h1>
            {intro && (
              <p className="mt-6 text-[#475569] text-lg leading-relaxed max-w-3xl">
                {intro}
              </p>
            )}
            <div className="mt-8 text-xs text-[#737373]">
              Last updated · {lastUpdated}
            </div>
          </div>
        </section>

        <section className="bg-white py-16 md:py-24">
          <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-[#0E2A57] tracking-tight">
                  {s.heading}
                </h2>
                <div className="mt-4 space-y-4 text-[#475569] text-base leading-relaxed">
                  {Array.isArray(s.body)
                    ? s.body.map((p, j) => <p key={j}>{p}</p>)
                    : <p>{s.body}</p>}
                  {s.list && (
                    <ul className="mt-4 list-disc pl-5 space-y-2">
                      {s.list.map((li, k) => (
                        <li key={k}>{li}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
